import { Ripple } from 'primereact/ripple';
import React from 'react';
import { numberToHebrewLetter } from '../../../../../../../../utils/hebrew-date-utils';
import { Button } from 'primereact/button';

interface SideBarSessionItemDatamodel {
  index: number;
  selectedIndex: number;
  setSessionIndex: (index: number) => any;
  handleDelete: () => any;
}
export const SideBarSessionItem: React.FC<SideBarSessionItemDatamodel> = ({
  index,
  selectedIndex,
  setSessionIndex,
  handleDelete,
}) => {
  const callHandleDelete = async () => handleDelete();

  return (
    <div
      onClick={() => setSessionIndex(index)}
      className={
        index === selectedIndex
          ? 'side-bar-session-item-selected'
          : `side-bar-session-item p-ripple`
      } // Add p-ripple class
      style={{
        height: '45px',
        position: 'relative',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingRight: '8px',
        gap: '4px',
        borderRadius: '4px',
        cursor: 'pointer',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <i className="pi pi-calendar mr-2"></i>
        <span className="font-medium">מועד {numberToHebrewLetter(index)}׳</span>
      </div>

      <Button
        icon="pi pi-trash"
        text
        style={{ zIndex: 100000 }}
        severity="danger"
        onClick={() => callHandleDelete()}
      />
      <Ripple />
    </div>
  );
};
